// Column menu behind the gear that appears on header hover (R-U4): sort, filter, move, hide, rename and field settings.

import { useState } from 'react';
import type { Id } from '@confdeck/core-shared';
import { useSync } from '../sync/react.tsx';
import { Input, Menu, MenuContent, MenuItem, MenuSeparator, MenuTrigger } from '../ui/primitives.tsx';
import { Icon } from '../ui/icons.tsx';
import type { TableColumn } from './DataTable.tsx';
import s from './table.module.css';

export function ColumnMenu({ typeId: _typeId, col, onSort, onFilter, onHide, onMove }: {
  typeId: Id; col: TableColumn; onSort: (d: 'asc' | 'desc' | null) => void; onFilter?: () => void; onHide: () => void; onMove: (dir: -1 | 1) => void;
}) {
  const client = useSync();
  const isOwner = client.store.meta.user(client.header?.userId)?.role === 'owner';
  const [renaming, setRenaming] = useState(false);
  const [name, setName] = useState(col.label);
  const f = col.field;
  return (
    <Menu>
      <MenuTrigger asChild>
        <button type="button" className={s.gear} aria-label={`Меню колонки «${col.label}»`} onClick={(e) => e.stopPropagation()}>
          <Icon name="gear" size={14} />
        </button>
      </MenuTrigger>
      <MenuContent align="end">
        {renaming ? (
          <div className={s.renameBox} onKeyDown={(e) => e.stopPropagation()}>
            <Input autoFocus value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => {
              if (e.key === 'Enter' && name.trim() && f) { client.mutate('field.update', { id: f.id, name: name.trim() }); setRenaming(false); }
              if (e.key === 'Escape') setRenaming(false);
            }} />
          </div>
        ) : (
          <>
            {!col.derived && <>
              <MenuItem icon="sort" onSelect={() => onSort('asc')}>По возрастанию</MenuItem>
              <MenuItem icon="sort" onSelect={() => onSort('desc')}>По убыванию</MenuItem>
              {onFilter && <MenuItem icon="filter" onSelect={onFilter}>Фильтр по полю</MenuItem>}
              <MenuSeparator />
            </>}
            <MenuItem icon="chevronRight" onSelect={() => onMove(1)}>Сдвинуть вправо</MenuItem>
            <MenuItem icon="chevronLeft" onSelect={() => onMove(-1)}>Сдвинуть влево</MenuItem>
            <MenuItem icon="eyeOff" onSelect={onHide}>Скрыть колонку</MenuItem>
            {f && isOwner && !f.system && (
              <>
                <MenuSeparator />
                <MenuItem icon="text" onSelect={(e) => { e.preventDefault(); setRenaming(true); }}>Переименовать поле</MenuItem>
              </>
            )}
          </>
        )}
      </MenuContent>
    </Menu>
  );
}
